import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import React from 'react'
import { SearchableSingleSelectDropdown } from '../../../components/FormikInputs'
import Loader from '../../../components/Loader'
import { Popup } from '../../../components/Popup'
import { countryList } from '../../../constants'
import { Box, Button, Text } from '../../../designSystem'
import { ActionBox } from '../style'
import { post } from '../../../lib/api'

function CountryPopup({isCountryPopupOpen, toggleCountryPopup, user, onUpdateUser, book, novelApply}) {
  return (
    <Popup
      show={isCountryPopupOpen}
      close={() => toggleCountryPopup(false)}
      renderActions={<></>}
    >
      <Text variant="heading">
        Select Nationality first, to proceed with Writer Benefit Application
      </Text>
      <Formik
        initialValues={{
          country: user?.location?.length > 2 ? '' : user?.location,
        }}
        validationSchema={Yup.object({
          country: Yup.string().required('Required'),
        })}
        onSubmit={(values) => {
          post('/user_api/user.update?is_novel=1', {
            data: { location: values.country },
          }).then(() => {
            toggleCountryPopup(false)
            onUpdateUser({ ...user, location: values.country })
            novelApply(book.book_id)
          })
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <Box my={8}>
              <SearchableSingleSelectDropdown
                label="Country"
                name="country"
                selectKey="code"
                nameKey="name"
                placeholder="Type to Search"
                valueArray={countryList}
                notAbsolutePosition
              />
            </Box>
            <ActionBox>
              <Button
                variant="outlinePrimary"
                onClick={() => toggleCountryPopup(false)}
              >
                Cancel{' '}
              </Button>
              {!isSubmitting && (
                <Button
                  ml={8}
                  variant="fillPrimary"
                  width={['100%', 'unset']}
                  type="submit"
                >
                  Save Nationality
                </Button>
              )}
              {isSubmitting && (
                <Button type="button">
                  <Loader invertColor inline size="sm" />
                </Button>
              )}
            </ActionBox>
          </Form>
        )}
      </Formik>
    </Popup>
  )
}

export default CountryPopup
